<div class="container-fluid error-page">

    <div class="row justify-content-center align-items-center min-vh-100">

        <div class="col-xl-10">

            <div class="error-card">

                <div class="row align-items-center">

                    <!-- Información -->

                    <div class="col-lg-6">

                        <span class="error-code">

                            Error 404

                        </span>

                        <h1>

                            No pudimos encontrar la página.

                        </h1>

                        <p>

                            Es posible que la página haya sido eliminada,
                            movida o que la dirección ingresada no sea válida.

                            Puedes regresar al panel principal o continuar
                            navegando desde las opciones disponibles.

                        </p>

                        <div class="d-flex flex-wrap gap-3 mt-4">

                            <a
                                routerLink="/"
                                class="btn btn-primary btn-lg">

                                <i class="mdi mdi-view-dashboard-outline me-2"></i>

                                Ir al Dashboard

                            </a>

                            <button
                                class="btn btn-outline-secondary btn-lg"
                                onclick="history.back()">

                                <i class="mdi mdi-arrow-left me-2"></i>

                                Regresar

                            </button>

                        </div>

                        <div class="row mt-5">

                            <div class="col-md-6 mb-3">

                                <div class="info-card">

                                    <i class="mdi mdi-magnify"></i>

                                    <h6>

                                        Revisa la URL

                                    </h6>

                                    <small>

                                        Verifica que la dirección sea correcta.

                                    </small>

                                </div>

                            </div>

                            <div class="col-md-6 mb-3">

                                <div class="info-card">

                                    <i class="mdi mdi-home-outline"></i>

                                    <h6>

                                        Inicio

                                    </h6>

                                    <small>

                                        Regresa al panel principal.

                                    </small>

                                </div>

                            </div>

                        </div>

                    </div>

                    <!-- Imagen -->

                    <div class="col-lg-6 text-center">

                        <img

                            src="assets/images/error-img.png"

                            class="img-fluid error-image"

                            alt="404">

                    </div>

                </div>

            </div>

        </div>

    </div>

</div>